





















/* Created- 19 - Aug - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaCardDialog from "../Common/Container/ParticaDialogCard.vue";
import { DateUtils } from "../../BusinessServices/dateutils";
import { ApiAuditModel } from "../../Generated/ParticaAPI";
@Component(
	{
		name: "PublicationStatusLog",
		components: { ParticaCardDialog }
	})
export default class PublicationStatusLog extends Vue {
	@Prop() private data: ApiAuditModel[]; // your data   
	private search: string = "";
	private showstats: boolean = false;
	private headers: any[] = [
		{ text: "Logtime", value: "logtime", sortable: true },
		{ text: "Method", value: "method", sortable: true },
		{ text: "User", value: "user", sortable: true },
	];
	private getFormat(date: Date) {
		return date.toISOString();
	}
}



